module.exports = __webpack_public_path__ + "img/layout.fa5fe66b.jpg";